/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
var ScrollPositionProvider_1 = require("./ScrollPositionProvider");
var Icon_1 = require("./Icon");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./ScrollToTopButton.css'); }
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-scrollToTopButton");
exports.ScrollToTopButton = function ScrollToTopButton(_a) {
    var visible = _a.visible, onClick = _a.onClick;
    return (React.createElement("button", { onClick: onClick, className: classnames(moduleClassName(), !!visible && moduleClassName("isVisible")) },
        React.createElement(Icon_1.Icon, { type: "arrow-up", className: moduleClassName("icon") })));
};
exports.ScrollToTopButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    visible: PropTypes.bool
};
var ScrollToTopButtonContextControlled = /** @class */ (function (_super) {
    tslib_1.__extends(ScrollToTopButtonContextControlled, _super);
    function ScrollToTopButtonContextControlled() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            var scrollContext = _this.context.scrollContext;
            if (scrollContext) {
                scrollContext.scrollTo(0, 0, true);
            }
        };
        return _this;
    }
    ScrollToTopButtonContextControlled.prototype.getVisibleState = function () {
        var scrollContext = this.context.scrollContext;
        var _a = this.props.verticalThreshold, verticalThreshold = _a === void 0 ? 500 : _a;
        if (scrollContext === undefined) {
            return false;
        }
        return (!scrollContext.didScrollDown &&
            scrollContext.pageYOffset > verticalThreshold);
    };
    ScrollToTopButtonContextControlled.prototype.render = function () {
        return (React.createElement(exports.ScrollToTopButton, { onClick: this.handleClick, visible: this.getVisibleState() }));
    };
    ScrollToTopButtonContextControlled.contextTypes = {
        scrollContext: ScrollPositionProvider_1.scrollContextType
    };
    ScrollToTopButtonContextControlled.propTypes = {
        verticalThreshold: PropTypes.number
    };
    ScrollToTopButtonContextControlled.defaultProps = {
        verticalThreshold: 500
    };
    return ScrollToTopButtonContextControlled;
}(React.Component));
exports.ScrollToTopButtonContextControlled = ScrollToTopButtonContextControlled;